import React from 'react';
import { Card, Stack, Box, Typography } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { BadgeField, NumberField, TextField, DateTimerField } from 'framework/ui/field';
import PriorityBadge from './badge/PriorityBadge';
import StatusNotification from './field/StatusNotification';
import ExpiredNotification from './field/ExpiredNotification';
import { People } from 'framework/ui/mui-builder';
import { VacancyGroupLinkField } from 'domain/shared/newVacancy';
import ViewStatusNotification from './field/ViewStatusNotification';

const EntityHeader: React.FC = () => {
  return (
    <Box
      sx={{
        position: 'sticky',
        zIndex: 100,
        p: '1px',
        left: 0,
        backgroundColor: 'background.default',
      }}
    >
      <Card
        sx={{
          border: '1px solid var(--mui-palette-border-warning)',
          maxHeight: 'max-content',
          minHeight: '96px',
          borderRadius: 1,
          p: '8px',
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'column',

          position: 'sticky',
          top: '64px',
        }}
      >
        <Stack direction="column">
          <Stack direction="row" alignItems="start" justifyContent="space-between" gap={1}>
            <Box>
              <ViewStatusNotification />
              <Typography component="span" variant="body2" color="primary">
                <VacancyGroupLinkField source="id" nameSource="name" />
              </Typography>
            </Box>
            <BadgeField badges={[<PriorityBadge idSource="id" prioritySource="priority" />]} />
          </Stack>
          <Typography variant="caption" color="textSecondary">
            <TextField source="specificNote" typographyProps={{ variant: 'caption', color: 'textSecondary' }} />
          </Typography>
        </Stack>

        <Stack direction="row" alignItems="center" gap={2}>
          <Stack direction="row" alignItems="center" gap={0.5}>
            <AccessTimeIcon sx={{ color: 'text.secondary', fontSize: 10 }} />
            <Typography variant="caption" color="textSecondary">
              <DateTimerField source="forecastDate" shortValue />
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={0.5}>
            <People sx={{ color: 'text.secondary', fontSize: 10 }} />
            <Typography variant="caption" color="textSecondary">
              <NumberField source="hired" /> / <NumberField source="needHire" />
            </Typography>
          </Stack>
        </Stack>
        <Stack direction="column" alignItems="start" sx={{ marginTop: 1 }}>
          <StatusNotification source="status" size="XS" />
          <ExpiredNotification source="isVacancyInsideGroupExpired" size="XS" />
        </Stack>
      </Card>
    </Box>
  );
};

export default EntityHeader;
